export const tealiumCheckoutPages: string[] = [
  'cart',
  'checkout/payment-type',
  'checkout/delivery-address',
  'checkout/payment-details',
  'checkout/review-order'
]

export const DIALOG_NAME_MAP: Record<string, string> = {
  ADDED_TO_CART: 'Modal: Added to cart',
  ADDRESS_VERIFICATION_MODAL: 'Modal: Address Verification',
  ADD_ENTRY_TO_SAVED_GEAR_MODAL: 'Modal: Add Entry to Saved Gear',
  ADD_PURCHASE_LIMIT_MODAL: 'Modal: Add new Purchase Limit',
  ADD_SAVED_GEAR_TO_CART: 'Modal: Add Saved Gear to Cart',
  CANCEL_QUOTE_MODAL: 'Modal: Cancel Quote',
  CHECKOUT_APPLY_STIPEND_MODAL: 'Modal: Apply Stipend',
  CLEAR_CART: 'Modal: Clear cart',
  CONFIRMATION_MODAL: 'Modal: Confirmation',
  DELETE_CART_MODAL: 'Modal: Delete Cart',
  DELETE_ENTRY_MODAL: 'Modal: Delete Entry',
  DELETE_SAVED_ENTRY_GROUP_MODAL: 'Modal: Delete Saved Group',
  EDIT_PURCHASE_LIMIT_MODAL: 'Modal: Edit Existing Purchase Limit',
  ESTIMATED_DELIVERY_DATES_MODAL: 'Modal: Estimated Delivery Dates',
  IDME_MODAL: 'Modal: ID.me Verification',
  IMPORT_SAVED_GEAR_MODAL: 'Modal: Import Saved Gear',
  MY_COMPANY_ADD_EDIT_STIPEND_MODAL: 'Modal: Add/Edit Stipend',
  MY_COMPANY_ADD_STIPEND_PAYMENT_METHOD: 'Modal: Add Stipend Payment Method',
  MY_COMPANY_BUDGET_FORM_MODAL: 'Modal: Budget Form',
  MY_COMPANY_EDIT_STIPEND_PAYMENT_METHOD: 'Modal: Edit Stipend Payment Method',
  MY_COMPANY_ADD_COST_CENTER_MODAL: 'Modal: Add Cost Center',
  MY_COMPANY_EDIT_COST_CENTER_MODAL: 'Modal: Edit Cost Center',
  OUT_OF_STOCK_MODAL: 'Modal: Out of Stock',
  PRODUCT_CUSTOMIZER_MODAL: 'Modal: Product Customizer',
  PRODUCT_BRANDING_MODAL: 'Modal: Product Branding',
  REMOVE_BRANDING_MODAL: 'Modal: Remove Branding',
  REMOVE_SAVED_GEAR: 'Modal: Remove Saved Gear',
  SAVE_CART_MODAL: 'Modal: Save Cart',
  EDIT_SIZES_MODAL: 'Modal: Edit Cart',
  SHIPPING_DETAILS_MODAL: 'Modal: Shipping Details'
}

export const tealiumPagesCustomizationMap: {
  [key: string]: {
    pageName: string;
    pageType: string;
  }
} = {
  '__HOMEPAGE__': {
    pageName: 'homepage',
    pageType: 'homepage'
  },
  'homepage': {
    pageName: 'homepage',
    pageType: 'homepage'
  },
  'home': {
    pageName: 'homepage',
    pageType: 'homepage'
  },
  '/': {
    pageName: 'homepage',
    pageType: 'homepage'
  },
  '/not-found': {
    pageName: 'page not found',
    pageType: 'error'
  },
  '/error': {
    pageName: 'error',
    pageType: 'error'
  },
  '/contact-us': {
    pageName: 'contact us',
    pageType: 'content'
  },
  '/callbacks/idme/auth-success': {
    pageName: 'success id page',
    pageType: 'checkout'
  },
  '/cart': {
    pageName: 'checkout: shopping bag',
    pageType: 'checkout'
  },
  '/checkout/payment-type': {
    pageName: 'checkout: payment type',
    pageType: 'checkout'
  },
  '/checkout/delivery-address': {
    pageName: 'checkout: shipping',
    pageType: 'checkout'
  },
  '/checkout/payment-details': {
    pageName: 'checkout: billing',
    pageType: 'checkout'
  },
  '/checkout/review-order': {
    pageName: 'checkout: order review',
    pageType: 'checkout'
  },
  '/checkout/confirmation': {
    pageName: 'checkout: order receipt',
    pageType: 'checkout'
  },
  '/my-account/account-overview': {
    pageName: 'account: account overview',
    pageType: 'account'
  },
  '/my-account/profile': {
    pageName: 'account: my profile',
    pageType: 'account'
  },
  '/my-account/address-book': {
    pageName: 'account: address book',
    pageType: 'account'
  },
  '/my-account/saved-gear': {
    pageName: 'account: saved gear',
    pageType: 'account'
  },
  '/my-account/saved-gear/:savedCartId': {
    pageName: 'account: saved gear details',
    pageType: 'account'
  },
  '/my-account/payment-methods': {
    pageName: 'account: payment methods',
    pageType: 'account'
  },
  '/my-account/review-proofs': {
    pageName: 'account: review proofs',
    pageType: 'account'
  },
  '/my-account/review-proofs/': {
    pageName: 'account: proofs details',
    pageType: 'account'
  },
  '/my-account/logo-library': {
    pageName: 'account: logo library',
    pageType: 'account'
  },
  '/my-account/orders': {
    pageName: 'account: order history',
    pageType: 'account'
  },
  '/my-account/order': {
    pageName: 'account: order details',
    pageType: 'account'
  },
  '/my-account/stipend-wallet': {
    pageName: 'account: stipend wallet',
    pageType: 'account'
  },
  '/my-account/order-approvals': {
    pageName: 'account: order approvals',
    pageType: 'account'
  },
  '/my-account/order-approvals/': {
    pageName: 'account: order approval details',
    pageType: 'account'
  },
  '/my-account/quotes': {
    pageName: 'account: quotes',
    pageType: 'account'
  },
  '/my-account/quotes/': {
    pageName: 'account: quote details',
    pageType: 'account'
  },
  '/my-company/business-units': {
    pageName: 'company: business units',
    pageType: 'company'
  },
  '/my-company/business-units-details': {
    pageName: 'company: business unit details',
    pageType: 'company'
  },
  '/my-company/users': {
    pageName: 'company: users',
    pageType: 'company'
  },
  '/my-company/user-details': {
    pageName: 'company: user details',
    pageType: 'company'
  },
  '/my-company/user-groups': {
    pageName: 'company: user groups',
    pageType: 'company'
  },
  '/my-company/user-groups/': {
    pageName: 'company: user group details',
    pageType: 'company'
  },
  '/my-company/stipend-payment-methods': {
    pageName: 'company: stipend payment methods',
    pageType: 'company'
  },
  '/my-company/stipend-payment-methods/': {
    pageName: 'company: stipend payment method details',
    pageType: 'company'
  },
  '/my-company/cost-centers': {
    pageName: 'company: cost centers',
    pageType: 'company'
  },
  '/my-company/cost-centers/': {
    pageName: 'company: cost center details',
    pageType: 'company'
  },
  '/my-company/cost-center-budgets': {
    pageName: 'company: cost center budgets',
    pageType: 'company'
  },
  '/my-company/cost-center-budgets/': {
    pageName: 'company: cost center budget details',
    pageType: 'company'
  },
  '/my-company/purchase-limits': {
    pageName: 'company: purchase limits',
    pageType: 'company'
  },
  '/my-company/purchase-limits/': {
    pageName: 'company: purchase limit details',
    pageType: 'company'
  },
  '/my-company/invoices': {
    pageName: 'company: invoices',
    pageType: 'company'
  },
  '/my-company/invoices/': {
    pageName: 'company: invoice details',
    pageType: 'company'
  },
  '/login/register': {
    pageName: 'account: new user registration',
    pageType: 'account'
  }
}
